// extracted by mini-css-extract-plugin
export default {"component":"azrJKr","isMobile":"Ic5rhW"};